import { maxSize } from 'constants/screenSize';
import {
  ScreenType,
  ScreenStyleConfig,
} from 'hooks/styleMediaQuery/useMediaQuery';

export const AccountPageConfigurations: Record<
  ScreenType,
  ScreenStyleConfig
> = {
  mobile: {
    mainBox: {
      style: {
        width: maxSize,
        overflowY: 'auto',
      },
    },
  },
  tablet: {
    mainBox: {
      style: { width: '80%', overflowY: 'auto' },
    },
  },
  largeScreen: {
    mainBox: {
      style: { width: '100%', overflowY: 'auto' },
    },
  },
};
